import { useTranslation } from 'react-i18next';
import { Card, Tooltip } from 'element-react';
import { S3Image } from '../components/S3Image';

export default function SupplierSwiperItem({ supplier }) {
    const { t } = useTranslation();
   
    let categoryName = 'Categoría no disponible'; // Valor por defecto

    // --- Lógica para extraer el nombre de la categoría ---
    // Verificamos que la propiedad 'featured_category' exista y tenga el formato esperado
    if (supplier.featured_category && supplier.featured_category.includes('|')) {
        // El string es "ID|Nombre". Lo partimos y tomamos la segunda parte (el nombre).
        const parts = supplier.featured_category.split('|');
        categoryName = parts[1]; 
    }

    // ---imagen principal 
    const defaultImageKey = "/DEEMSA/cover_picture/1628555070378-cover_picture-003.jpg";
    
    const redirectToSupplierStore = () => { 
        window.open("/company-store/"+ supplier.name.replace(/\//g, "").replace(/\s+/g, "-").toUpperCase() + "/" + supplier.id, "_blank");
    };

    const principalImageThemeConfig = {
        photoImg: {
            maxWidth: "250px",
            maxHeight: "180px",
            minHeight: "125px",
            borderRadius: "20px"
        }
    };

    const supplierImageKey = supplier.cover_picture?.key || defaultImageKey;

    return (
        <Card className="supplier-swiper-item" bodyStyle={{ padding: 0 }}>
            <div className="text-center" >
                <S3Image 
                    imgKey={supplierImageKey} 
                    theme={principalImageThemeConfig} 
                    level="public" 
                    onClick={redirectToSupplierStore} 
                    className="cursor"
                />
            </div>
            
            <div style={{ padding: '14px' }}>
                {/* Nombre del proveedor */}
                <Tooltip
                effect="dark" 
                content={supplier.name} 
                placement="bottom" 
                trigger="click"
                >
                <p style={{fontWeight: 'bold', fontSize: '16px', margin: '0 0 0 0', height: '50px'}}>
                    {supplier.name}
                </p></Tooltip>
                
                {/* Nombre de la categoría */}
                <p style={{fontSize: '14px', color: '#2c2689', margin: 0}}>
                    {categoryName}
                </p>
            </div>
        </Card>
    );
}